/* unplugin-vue-components disabled */import { render } from "./logicNew.vue?vue&type=template&id=c2e69366&scoped=true"
import script from "./logicNew.vue?vue&type=script&lang=js"
export * from "./logicNew.vue?vue&type=script&lang=js"

import "./logicNew.vue?vue&type=style&index=0&id=c2e69366&scoped=true&lang=css"
import "./logicNew.vue?vue&type=style&index=1&id=c2e69366&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e69366"]])

export default __exports__